import { createAction } from 'redux-actions'
import { createGenericTypes, createGenericActions } from 'utils/createAction'

export const setRyeShopifyStoreType = 'SET_RYE_SHOPIFY_STORES'
export const setRyeShopifyStoreAction = createAction(setRyeShopifyStoreType)

export const triggerRyeCheckCollectionType = 'TRIGGER_RYE_CHECK_COLLECTION'
export const triggerRyeCheckCollectionAction = createAction(
  triggerRyeCheckCollectionType
)

export const reorderRyeShopifyStoreTypes = createGenericTypes(
  'REORDER_RYE_SHOPIFY_STORE'
)

export const reorderRyeShopifyStoreActions = createGenericActions(
  reorderRyeShopifyStoreTypes
)
